import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { queryClient } from "./lib/react-query";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { routes } from "./routes";

import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import "./css/bootstrap.scss";
import "./css/style.scss";

const router = createBrowserRouter(routes);
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<p>Something went wrong :(</p>}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools position="bottom-left" />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
